<!--团队业绩-->
<template>
	<div style="height:100%">
		<div class="handleBox flex flex-ai-c">
			<el-page-header @back="goBack" content="团队业绩" style="color:#95A1B9"></el-page-header>
            <el-input placeholder="订单编号/姓名/电话/会员ID" v-model="select.wd" size="small" @change="curr=1;getList()" class="input-with-select" style="width:300px;margin:0 auto">
				<el-button slot="append" icon="el-icon-search" ></el-button>
			</el-input>
		</div>

		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 140px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )" :cell-style="{color:'#515a6e',borderColor:'#E8EAEC'}" :header-cell-style="{background:'#F8F8F9',color:'#515A6E'}">
                <el-table-column label="订单信息" min-width="350" show-overflow-tooltip>
					<template slot-scope="scope">
                        <div class="order-summary">
							<i class="el-icon-s-order"></i>
							<span class="order_num">订单号：{{scope.row.order_num}}</span>
							<span>下单时间：{{scope.row.create_time_format}}</span>
						</div>
						<div v-for="(goods, index) in scope.row.goods" :key="index" class="flex storeOrder">
							<el-image class="pic" :src="getImgUrl(goods.goods_pic)" :preview-src-list="[getImgUrl(goods.goods_pic)]" fit="cover">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline" style="font-size:70px"></i>
								</div>
							</el-image>
							<div class="order-text">
								<p class="ellipsis">{{goods.goods_name}}</p>
								<p class="son ellipsis">价格：{{goods.price}} x {{goods.number}}</p>
                                <p class="son ellipsis">规格：{{goods.scpecs_id}}</p>
								<p class="son ellipsis">小计：{{goods.total}}元</p>
							</div>
						</div>
					</template>
				</el-table-column>
                <el-table-column prop="nickname" label="下单人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status_name" label="订单状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status_id == 1 || scope.row.status_id == 8 || scope.row.status_id == 10  ? 'danger' : scope.row.status_id == 2 ? 'warning' : scope.row.status_id == 3 || scope.row.status_id == 4 || scope.row.status_id == 5 || scope.row.status_id == 9  ? 'success' : 'info'" size="small">{{scope.row.status_name}}</el-tag>
					</template>
                </el-table-column>
                <el-table-column prop="amount" label="订单金额(元)" show-overflow-tooltip></el-table-column>
				<el-table-column prop="amount_payable" label="业绩(元)" show-overflow-tooltip></el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
                select:{},

				curr: 1, //页码
				row: 10, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
                searchValue:''
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			//团队业绩列表
			getList() {
				this.http.post('/admin/user/getTeamOrderList', {
					curr: this.curr,
					row: this.row,
                    user_id:this.$route.query.id
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},
            //图片路径转换
			getImgUrl: function(url){
				return this.domain + '/' + url;
			},
            //返回
			goBack: function(){
				this.$router.go(-1)
			},

			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			}
		}
	}
</script>
<style scoped>
    .order-summary{
        margin-bottom: 15px;
    }
    .order-summary .order_num{
        margin-right: 8px;
    }
</style>
